<template>
	<div v-if="!underMaintainance">
		<div v-if="$route.meta.lightweight" class="overflow-data h-100vh">
			<router-view/>
		</div>
		<template v-else-if="$route.meta.requiresAuth">
			<template v-if="logged && (rules && Object.keys(rules).length && companyUserDetail && Object.keys(companyUserDetail).length)">
                <HeaderComponent v-if="!$route.meta.hideHeader" @change="changeCompany($event)" @filter="handleFilter"/>
                <div class="app-wrapper">
                    <SidebarComponent />
                    <div class="billing__history-wrapper style-scroll overflow-auto">
                    <AdvanceSearchModal
                        v-if="!$route.meta.preventAdvanceSearch"
                        headerClasses="border-0"
                        :modelValue="isAdvanceSearch"
                        :header="false"
                        :footer="false"
                        :showCloseIcon="false"
                        :className="`advance_search_modal advanced__model-css`"
                        @removeListners="removeKeyListner"
                    >
                        <template #body>
                            <MainSearchComponent @closeModel="removeKeyListner"/>
                        </template>
                    </AdvanceSearchModal>
                    <router-view/>
                    <TourCom ref="mainTour"/>
                </div>
                </div>
			</template>
			<div v-else-if="!companyId?.length && $route.name === 'Create_Company'" class="d-flex align-items-center justify-content-center lds-roller h-100dvh">
				<router-view/>
			</div>
			<div v-else class="d-flex align-items-center justify-content-center lds-roller h-100dvh">
				<img :src="logo" alt="logo" class="position-ab z-index-1 company__logo">
				<div class="spinner"></div>
			</div>
		</template>
		<div v-else class="overflow-data h-100vh">
			<router-view/>
		</div>
        <template v-if="userId && showReviewModal">
            <ReviewPromptModal/>
        </template>
        <Modal
            v-if="showPhoneRequiredModal"
            v-model="showPhoneRequiredModal"
            :title="$t('Profile.phone_required_title')"
            :acceptButtonText="$t('Profile.go_to_settings')"
            :cancelButton="false"
            :close-on-backdrop="false"
            :closeIcon="false"
            className="missing-phone-modal"
            @accept="goToMyProfile"
        >
            <template #body>
                <div class="missing-phone-wrapper">
                    <p class="missing-phone-message">{{ $t('Profile.phone_required_message') }}</p>
                </div>
            </template>
        </Modal>
        <!-- NOTIFICATION REQUEST MODAL -->
        <Modal
            v-if="requestPermission && !showPhoneRequiredModal"
            v-model="requestPermission"
            :title="$t('Home.Notification_Request')"
            :cancelButtonText="$t('Home.no')"
            :acceptButtonText="$t('Home.yes')"
            :close-on-backdrop="false"
            :closeIcon="false"
            className="topAligned"
            @close="requestPermission = false;showReviewModal=true;"
            @accept="notificationPermissionRequest(), requestPermission = false;showReviewModal=true;"
        >
            <template #body>
                <div class="d-flex align-items-center flex-column px-2">
                    {{$t('Home.are_you_sure')}}
                </div>
            </template>
        </Modal>
        <UpgradeProcessModel 
            v-if="openReleaseNoteModel === true" 
            :openReleaseNoteModel="openReleaseNoteModel"
            :fromWhich="'App'"
            @closeReleaseNoteModel="(val) => {openReleaseNoteModel = val}" >
        </UpgradeProcessModel>
	</div>
	<div v-else class="d-flex align-items-center justify-content-center w-100vw h-100dvh">
		<img :src="underMaintainanceImg" alt="underMaintainance">
	</div>
    <TakeNote
        :visible="isUserNote"
        @close="toggleUserNote(false)"
    />
    <UserProfileModal
        v-if="profileUserId"
        :userId="profileUserId"
        @close="profileUserId = ''"
    />
    <BirthdayCelebration :visible="birthdayCelebrationVisible" :names="birthdayCelebrationNames" />

</template>
<script setup>
// PACKAGES
import { computed, defineComponent, onBeforeUnmount, onMounted, provide, ref, watch } from 'vue'
// COMPONENTS
import TourCom from "@/components/organisms/Tour/TourComponet.vue"
import HeaderComponent from '@/components/organisms/Header/Header.vue'
import SidebarComponent from '@/components/organisms/MainSidebar/MainSidebar.vue'
import AdvanceSearchModal from '@/components/atom/Modal/Modal.vue'
import Modal from "@/components/atom/Modal/Modal.vue"
import MainSearchComponent from '@/components/molecules/AdvanceSearch/MainComponent.vue'
import { useStore } from 'vuex';
import axios from 'axios'
import { fcmToken } from '@/composable/commonFunction';
import { useToast } from "vue-toast-notification"
import TakeNote from '@/views/TakeNote/TakeNote.vue'
import UserProfileModal from '@/components/organisms/UserProfileModal/UserProfileModal.vue'
import BirthdayCelebration from '@/components/organisms/BirthdayCelebration/BirthdayCelebration.vue'

// COMPOSABLES
const { getters, dispatch, commit } = useStore();
const $toast = useToast();
import { useI18n } from "vue-i18n";
const { t } = useI18n();
// const paymentInit = inject("paymentInit");
// IMAGES
// import logo from '@/assets/images/png/logo.png'
const logo = "/api/v1/getlogo?key=logo&type=desktop";
import underMaintainanceImg from '@/assets/images/under_maintenance.png'
import { useRoute, useRouter } from 'vue-router';
import { languageTranslateHelper } from './composable/index';
import {useSocketManager} from './composable/useSocketManager';
import { useCustomComposable } from '@/composable';
import { apiRequest,apiRequestWithoutCompnay } from './services';
import * as env from '@/config/env';
import {tabSyncHelper} from '@/utils/tabSyncs.js';
import Cookies from 'js-cookie'
import { english } from '@/locales/en';
const {tabSync} = tabSyncHelper();
const mainTour = ref();
const profileUserId = ref('');

const openUserProfileHandler = (event) => {
    profileUserId.value = event?.detail?.userId || '';
};

// COMPONENT
defineComponent({
    name: 'App',

	components: {
        HeaderComponent,
        AdvanceSearchModal,
        SidebarComponent
	}
})

const {selectedLanguageCode, changeLanguage} = languageTranslateHelper();
const { locale, setLocaleMessage } = useI18n();
const { checkPermission } = useCustomComposable();

const mergeLocaleMessages = (fallback = {}, remote = {}) => {
    if (!remote || typeof remote !== 'object' || Array.isArray(remote)) {
        return { ...fallback };
    }

    return Object.keys(remote).reduce((messages, key) => {
        const fallbackValue = fallback?.[key];
        const remoteValue = remote[key];
        messages[key] = fallbackValue && typeof fallbackValue === 'object' && !Array.isArray(fallbackValue)
            ? mergeLocaleMessages(fallbackValue, remoteValue)
            : remoteValue;
        return messages;
    }, { ...fallback });
}

const setSafeLocaleMessage = (languageCode, remoteMessages) => {
    setLocaleMessage(languageCode, mergeLocaleMessages(english, remoteMessages));
}

const companyId = ref(localStorage.getItem('selectedCompany') !== null ? localStorage.getItem('selectedCompany') : "")
const underMaintainance = ref(false);
const logged = ref(false);
const requestPermission = ref(false);
const showReviewModal = ref(false);
const showSpinner = ref(true);
const clientWidth = ref(document.documentElement.clientWidth);
const userId = ref('');
const router = useRouter();
const route = useRoute();
const dateFormat = ref("DD/MM/YYYY");
const isAdvanceSearch = ref(false);
const openReleaseNoteModel = ref(false);
const loggedUserDetail = ref({});
const defaultImageUser = require("@/assets/images/default_user.png")
const socket = ref(null);
const birthdayCelebrationVisible = ref(false);
const birthdayCelebrationNames = ref([]);
let birthdayCelebrationTimer = null;
let presenceRefreshInterval = null;
let socketVisibilityDebounce = null;
let socketVisibilityHandler = null;
let socketBeforeUnloadHandler = null;
const defaultTaskStatus = require("@/assets/images/defaut_task_status_img.png");
const defaultGhostCustomUser = `${env.API_URI}/api/v1/getlogo?key=ghostuser`;

const rules = ref({});
const projectList = computed(() => checkPermission('project.project_list'));
const taskList = computed(() => checkPermission('task.task_list'));
const currentCompany = computed(() => getters["settings/selectedCompany"]);
const {connectServer} = useSocketManager();
const currentUser = computed(() => getters["users/currentUser"]);
const companyUsersForBirthday = computed(() => getters["users/users"] || []);

const birthdayMonthDay = (user) => {
    const value = user?.birthday || user?.dateOfBirth || user?.Birthday || user?.birthday_day_month;
    if (!value) return null;

    if (typeof value === 'object' && (value.seconds !== undefined || value._seconds !== undefined)) {
        const date = new Date(Number(value.seconds ?? value._seconds) * 1000);
        return Number.isNaN(date.getTime()) ? null : [date.getMonth() + 1, date.getDate()];
    }

    const text = String(value).trim();
    let match = text.match(/^(\d{4})-(\d{2})-(\d{2})/);
    if (match) return [Number(match[2]), Number(match[3])];
    match = text.match(/^(\d{2})\/(\d{2})\/(\d{4})$/);
    if (match) return [Number(match[2]), Number(match[1])];
    match = text.match(/^(\d{2})-(\d{2})$/);
    if (match) return [Number(match[1]), Number(match[2])];

    const date = new Date(value);
    return Number.isNaN(date.getTime()) ? null : [date.getMonth() + 1, date.getDate()];
};

const birthdayUsersToday = computed(() => {
    const now = new Date();
    const month = now.getMonth() + 1;
    const day = now.getDate();
    return companyUsersForBirthday.value.filter((user) => {
        const birthday = birthdayMonthDay(user);
        return birthday?.[0] === month && birthday?.[1] === day;
    });
});

watch([logged, birthdayUsersToday], ([isLoggedIn, birthdayUsers]) => {
    if (!isLoggedIn || !birthdayUsers.length || birthdayCelebrationVisible.value) return;

    const now = new Date();
    const dayKey = [now.getFullYear(), String(now.getMonth() + 1).padStart(2, '0'), String(now.getDate()).padStart(2, '0')].join('-');
    const storageKey = `birthday-celebration:${companyId.value}:${dayKey}`;
    if (localStorage.getItem(storageKey)) return;

    birthdayCelebrationNames.value = birthdayUsers.map((user) => user.Employee_Name || user.name || user.userEmail).filter(Boolean);
    localStorage.setItem(storageKey, 'shown');
    birthdayCelebrationVisible.value = true;
    clearTimeout(birthdayCelebrationTimer);
    birthdayCelebrationTimer = setTimeout(() => {
        birthdayCelebrationVisible.value = false;
    }, 6500);
}, { immediate: true });
const phoneCheckUser = computed(() => {
    return currentUser.value && Object.keys(currentUser.value).length ? currentUser.value : loggedUserDetail.value;
});
const showPhoneRequiredModal = computed({
    get() {
        return Boolean(
            route.meta.requiresAuth &&
            route.name !== 'My Profile' &&
            (logged.value || Cookies.get('accessToken')) &&
            userId.value &&
            phoneCheckUser.value &&
            Object.keys(phoneCheckUser.value).length &&
            !getUserPhone(phoneCheckUser.value)
        );
    },
    set() {}
});

watch(() => phoneCheckUser.value, (val) => {
    if(val?.isVesionUpdate){
        openReleaseNoteModel.value = true;
    }
})

function normalizePhone(value) {
    return value == null ? '' : String(value).trim();
}

function getUserPhone(user = {}) {
    return [user.phone, user.phoneNumber, user.Employee_Phone, user.Employee_phone]
        .map(normalizePhone)
        .find(Boolean) || '';
}

function goToMyProfile() {
    router.push({
        name: 'My Profile',
        params: {
            cid: companyId.value || route.params.cid || localStorage.getItem('selectedCompany') || ''
        }
    }).catch((error) => {
        console.error("ERROR in redirect to my profile: ", error);
    });
}


watch(() => getters['settings/rules'], (val) => {
	rules.value = val;
})
watch(route, (newVal) => {
	const token = Cookies.get('accessToken') || '';
    if(newVal?.name === 'Support'){
        if(token && !companyId.value){
            return router.push({name : 'Create_Company'});
        }
        return;
    } else if(newVal.params.cid && newVal.params.cid !== companyId.value){
        changeCompany(newVal.params.cid);
    } else if(!companyId.value && token){
        router.push({name : 'Create_Company'});
    }
})

function checkUserCompany (uid,forDisable = false) {
    return new Promise((resolve,reject) => {
        try {
            apiRequestWithoutCompnay('get',`${env.USER_UPATE}/${uid}`)
            .then((res) => {
                if(res.status === 200){
                    const result = res.data;
                    if(result?.AssignCompany.length === 0){
                        resolve("");
                        rules.value = {};
                        localStorage.removeItem("selectedCompany");
                        commit("settings/mutateSelectedCompany", companyId.value);
                        companyId.value = '';
                        router.push('/business');
                        return;
                    }else{
                        if(forDisable){
                            const comapnyValue = getters['settings/companies'].filter((cmp) => result?.AssignCompany.includes(cmp._id)).find((x) => x.isDisable == false);
                            if(comapnyValue){
                                resolve(comapnyValue._id || "");
                            }else{
                                resolve("");
                            }
                        }else{
                            resolve(result?.AssignCompany[0] || "");
                        }
                    }
                }else{
                    reject(res.message);
                    $toast.error(t("generalErrorMessage.something_went_wrong"),{position: 'top-right'});
                }
            })
        } catch (error) {
            reject(error)
        }
    })
}

const companyUserDetail = ref({});
watch(() => getters['settings/companyUserDetail'], async(val) => {
    if(val.isDelete === true){
        await checkUserCompany(userId.value).then((response) => {
            localStorage.removeItem("selectedCompany");
            companyId.value = '';
            if(!Object.keys(companyId.value).length){
                companyId.value = response;
                commit("settings/mutateSelectedCompany", companyId.value);
                if(response !== ""){
                    localStorage.setItem("selectedCompany",companyId.value);
                }
            }
            return true;
        }).catch((err) => {
            console.error(err,"errerr");
        })
        setTimeout(() => {
        }, 1000);
    }
	companyUserDetail.value = val;
})

watch(() => getters['settings/selectedCompany'], async(val) => {
    if(val.isDisable === true){
        await checkUserCompany(userId.value,true).then((response) => {
            if(response === ''){
                companyId.value = '';
                localStorage.removeItem("selectedCompany");
            }else{
                companyId.value = response;
                commit("settings/mutateSelectedCompany", companyId.value);
                if(response !== ""){
                    localStorage.setItem("selectedCompany",companyId.value);
                }
            }
            return true;
        }).catch((err) => {
            console.error(err,"errerr");
        })
        setTimeout(() => {
        }, 1000);
    }
})

async function getFirebaseData() {
    if (route.meta.lightweight || route.name === 'PreviewAttachments') {
        return;
    }

    if(getters['settings/companies'] && !getters['settings/companies'].length) {
        let localUserId = localStorage.getItem("userId") || null;
        
        const userDetail = localUserId?  await apiRequestWithoutCompnay('get',`${env.USER_UPATE}/${localUserId}`) : null;
        if (userDetail) {
            let user = userDetail.data
            
            if(user) {
                userId.value = user._id;
                
                localStorage.setItem('logged', true);

                const userResult = await apiRequestWithoutCompnay('get',`${env.USER_UPATE}/${userId.value}`);
                let userData = {}

                if(userResult.status === 200){
                    userData = userResult.data;
                    loggedUserDetail.value = userData;
                }

                if(userData.languageCode){
                    localStorage.setItem('language', userData.languageCode);
                    const updateLanguage = await changeLanguage(userData.languageCode);
                    locale.value = userData.languageCode;
                    setSafeLocaleMessage(userData.languageCode, updateLanguage?.data);
                }

                await dispatch('settings/setCompanies', userData?.AssignCompany)
                .catch((error) => {
                    console.error("ERROR in set companies: ", error)
                    return;
                })

                if(userData?.AssignCompany.length > 0){
                    if(!userData?.AssignCompany.includes(companyId.value)) {
                        let findCompany = getters['settings/companies'].filter((x) => userData?.AssignCompany.includes(x._id)).filter((y) => y.isDisable === undefined || y.isDisable === false);
                        if(findCompany.length > 0){
                            await changeCompany(findCompany[0]._id)
                        }else{
                            router.push('/business');
                        }
                    }
                }else{
                    router.push('/business');
                }


                if(!companyId.value?.length){
                    checkUserCompany(userId.value)
                    return;
                }
                commit("settings/mutateSelectedCompany", companyId.value);

                dispatch("users/setUsers", {cid: companyId.value}).then(() => {
                    logged.value = true;
                }).catch((error) => {
                    logged.value = true;
                    console.error("ERROR in setUsers: ", error);
                }); 
                if (getters['ToursData/Tours'] && !(getters['ToursData/Tours'])?.length) {
                      dispatch('ToursData/getTours',userData.tour)
                         .catch((error) => {
                         console.error('ERROR in getTours:', error);
                         });
                      } 


                if(getters['settings/rules'] && !getters['settings/rules'].length) {
                    dispatch("settings/setRules", companyId.value).then(() => {
                        if(getters['settings/allCurrencyArray'] && !(getters['settings/allCurrencyArray']).length){
                            dispatch('settings/setCurrencyArray', companyId.value).catch((error) =>{
                                console.error('ERROR in set AllProjectStatus',error)
                            })
                        }
                        if(getters['settings/roles'] && !getters['settings/roles'].length) {
                            dispatch('settings/setRoles', companyId.value)
                            .catch((error) => {
                                console.error("ERROR in set roles: ", error)
                            })
                        }
                        if(getters['settings/designations'] && !getters['settings/designations'].length) {
                            dispatch('settings/setDesignations', companyId.value)
                            .catch((error) => {
                                console.error("ERROR in set designations: ", error)
                            })
                        }
                        if(getters['settings/companyUserStatus'] && !getters['settings/companyUserStatus'].length) {
                            dispatch('settings/setCompanyUserStatus', companyId.value)
                            .catch((error) => {
                                console.error("ERROR in set company user status: ", error)
                            })
                        }
                        if(getters['settings/fileExtentions'] && !Object.keys(getters['settings/fileExtentions']).length) {
                            dispatch('settings/setFileExtentions', companyId.value)
                            .catch((error) => {
                                console.error("ERROR in set file extentions: ", error)
                            })
                        }
                        if(getters['settings/companyUsers'] && !getters['settings/companyUsers'].length) {
                            dispatch('settings/setCompanyUsers', {companyName: companyId.value, userId: userId.value}).then(async()=>{
                                    if (userId.value !== null && companyId.value) {
                                        handleSocketsConnection();
                                        if (process.env.VUE_APP_AFFILIATEON == 'true') {
                                            dispatch('settings/setCompanyRefferal',companyId.value).catch((error)=>{
                                                console.error(error);
                                            })
                                        }
                                    }
                                    if(getters['settings/chargeBeePrice'] && !(getters['settings/chargeBeePrice']).length){
                                        dispatch('settings/setChargeBeePrice').catch((error) =>{
                                            console.error('ERROR in set Set Chargebee',error)
                                        })
                                    }
                                    if(process.env.VUE_APP_PAYMENTMETHOD && getters['settings/planFeatureDisplay'] && !(getters['settings/planFeatureDisplay']).length){
                                        dispatch('settings/setplanFeatureDisplay').catch((error) =>{
                                            console.error('ERROR in set Set Chargebee',error)
                                        })
                                    }
                            })
                            .catch((error) => {
                                console.error("ERROR in set file extentions: ", error)
                            })
                        }
                        if(getters['settings/category'] && !getters['settings/category'].length) {
                            dispatch('settings/setCategory',companyId.value)
                            .catch((error) => {
                                console.error("ERROR in set file extentions: ", error)
                            })
                        }
                        // STORE IMPLEMENTATION PENFINDING
                        // if(self.users && !Object.keys(self.users).length) {
                        //     let whereQueries= [
                        //         {
                        //             field: "AssignCompany",
                        //             operation: "array-contains",
                        //             value: Vue.prototype.$companyId
                        //         },
                        //         {
                        //             field: "isDeleted",
                        //             operation: "==",
                        //             value: false
                        //         },
                        //         {
                        //             field: "isActive",
                        //             operation: "==",
                        //             value: true
                        //         },
                        //     ]
                        //     self.setUsers({
                        //         whereQueries: whereQueries
                        //     })
                        //     .catch((error) => {
                        //         console.error("ERROR in get users: ", error);
                        //     })
                        // }
                        // if(self.teams && !Object.keys(self.teams).length) {
                        //     self.setTeams({"cid":Vue.prototype.$companyId});
                        // }
                        if(getters['settings/projectTabComponents'] && !getters['settings/projectTabComponents'].length) {
                            dispatch('settings/setProjectTabComponents', companyId.value)
                            .catch((error) => {
                                console.error("ERROR in set project tab components: ", error)
                            })
                        }
                        if(getters['settings/companyDateFormat'] && !getters['settings/companyDateFormat'].length) {
                            dispatch('settings/setCompayDateFormat', companyId.value)
                            .then((res) => {
                                dateFormat.value = res?.settings[0].dateFormat || "DD-MM-YYYY"
                            })
                            .catch((error) => {
                                console.error("ERROR in set Compay Date Format: ", error)
                            })
                        }
                        if(getters['settings/companyPriority'] && !(getters['settings/companyPriority']).length) {
                            dispatch('settings/setCompanyPriority', companyId.value)
                            .catch((error) => {
                                console.error("ERROR in set setCompanyPriority: ", error)
                            })
                        }
                        if(getters['settings/reactionEmoji'] && !(getters['settings/reactionEmoji']).length) {
                            dispatch('settings/setReactionEmoji', companyId.value)
                            .catch((error) => {
                                console.error("ERROR in set setreactionEmoji: ", error)
                            })
                        }
                        if(getters['settings/milestoneweeklyrange'] && !(getters['settings/milestoneweeklyrange']).length) {
                            dispatch('settings/setMileStoneWeeklyRange', companyId.value)
                            .catch((error) => {
                                console.error("ERROR in set setMileStoneWeeklyRange: ", error)
                            })
                        }
                        if(getters['settings/teams'] && !(getters['settings/teams']).length) {
                            dispatch('settings/setTeams', companyId.value)
                            .catch((error) => {
                                console.error("ERROR in set setTeams: ", error)
                            })
                        }
                        if(getters['settings/customFields'] && !(getters['settings/customFields']).length) {
                            dispatch('settings/setCustomFields', companyId.value)
                            .catch((error) => {
                                console.error("ERROR in set setCustomFields: ", error)
                            })
                        }
                        if(getters['settings/restrictedExtensions'] && !(getters['settings/restrictedExtensions']).length) {
                            dispatch('settings/setRestrictedExtensions', companyId.value)
                            .catch((error) => {
                            console.error("ERROR in set setTeams: ", error)
                            })
                        }
                        if(getters['settings/projectMilestoneStatus'] && !(getters['settings/projectMilestoneStatus']).length) {
                            dispatch('settings/setMileStoneStatus', companyId.value)
                            .catch((error) => {
                                console.error("ERROR in set setTeams: ", error)
                            })
                        }
                        if(getters['settings/finalCustomFields'] && !(getters['settings/finalCustomFields']).length) {
                            dispatch('settings/setfinalCustomFields', companyId.value) .catch((error) => {
                                console.error("ERROR in set finalCustomFields: ", error)
                            })
                        }
                        if(getters['settings/AllTaskStatus'] && !(getters['settings/AllTaskStatus']).length){
                            dispatch('settings/setTaskStatusArray', companyId.value).catch((error) =>{
                                console.error('ERROR in set AllTaskStatus',error)
                            })
                        }
                        if(getters['settings/AllProjectStatus'] && !(getters['settings/AllProjectStatus']).length){
                            dispatch('settings/setProjectStatusArray', companyId.value).catch((error) =>{
                                console.error('ERROR in set AllProjectStatus',error)
                            })
                        }
                        if(getters['settings/AllTaskType'] && !(getters['settings/AllTaskType']).length){
                            dispatch('settings/setTaskTypeArray', companyId.value).catch((error) =>{
                                console.error('ERROR in set AllTaskType',error)
                            })
                        }
                        if(getters['settings/projectStaus'] && !(getters['settings/projectStaus']).length) {
                            dispatch('settings/setProjectStatus', companyId.value).then(()=>{
                            }).catch((err)=>{
                                console.error(err,"Error in set project status template")
                            })
                        }
                        if(getters['settings/taskType'] && !(getters['settings/taskType']).length) {
                            dispatch('settings/setTaskType', companyId.value).then(() => {
                            })
                            .catch((error) => {
                                console.error("ERROR in set setTaskType: ", error)
                            })
                        }
                        if(getters['settings/taskStatus'] && !(getters['settings/taskStatus']).length) {
                            dispatch('settings/setTaskStatus', companyId.value)
                            .catch((error) => {
                                console.error("ERROR in set setTaskStatus: ", error)
                            })
                        }
                    }).catch((error) => {
                        console.error("ERROR in get rules: ", error);
                    })
                }

                if ('Notification' in window) {
                    if(Notification.permission === "default") {
                        requestPermission.value = true;
                    } else if(Notification.permission === "granted") {
                        generateFcmToken();
                        showReviewModal.value = true;
                    } else {
                        showReviewModal.value = true;
                    }
                } else {
                    showReviewModal.value = true;
                }
            }
        } else {
            logged.value = false;
            localStorage.setItem('logged', false);
            showSpinner.value = false;
        }
	}
}
async function changeCompany(cid) {
    try {
        const uid = userId.value || localStorage.getItem("userId");
        const companyDetail = getters['settings/companies'].find((x) => x._id === cid)
		const token = Cookies.get('accessToken') || '';
        if(!companyDetail && !getters['settings/companies'].length && token){
            router.push({name : 'Create_Company'});
            return;
        }
        let checkCompany = companyDetail?.isDisable || false;
        const userDataRes = await apiRequest('get',`${env.USER_UPATE}/${uid}`);
        let userData = {}
        if(userDataRes.status === 200){
            userData = userDataRes.data;
        }
        let availableCompany = userData?.AssignCompany.find((x) => x === cid);
        if(!availableCompany){
            let routeObj = {name: route.name, params: {cid: companyId.value}};
            router.replace(routeObj);
            return;
        }
        if(checkCompany === false){
            companyId.value = cid;
            commit("settings/mutateSelectedCompany", companyId.value);

            localStorage.setItem('selectedCompany', companyId.value);
            let routeObj = {name: route.name, params: {cid: ""}};
            if(route?.params?.cid) {
                routeObj.params.cid = cid;
                routeObj.params.id = route?.params?.id || "";
            }
            router.replace(routeObj)
            .then(async() => {
                try {
                    await apiRequest("post",env.CACHECLEAR,{cacheKey: `UserProjectData:${uid}`});
                    await apiRequest("post",env.CACHECLEAR,{cacheKey: `dashboard_${uid}`});
                } catch (error) {
                    console.error("Error in cacheClear",error);
                }
            })
            .catch((error) => {
                console.error("ERROR in change company: ", error);
            })
        }else{
            $toast.error(t("Toast.Company_is_disable"),{position: 'top-right'});
            let availableCompany = getters['settings/companies'].find((x) => !x.isDisable);
            if(availableCompany){
                router.replace({name: route.name, params: {cid: availableCompany._id}});
            }else{
                router.push({name : 'Create_Company'});
            }
        }
    } catch (error) {
        console.error("ERROR in change company: ", error);
    }
}
const handleFilter = () => {
    isAdvanceSearch.value = true;
}
// This function is used for the handle advance search modal key press event
const _keyListener = (e) => {
    if (e.key === "k" && (e.ctrlKey)) {
        if(checkPermission('task.advance_search') !== true) {
            return;
        }
        if(!currentCompany.value?.planFeature?.advanceFilterCtrlK) {
            $toast.error(t('Toast.advance_search_feature_upgrade_message'),{position: 'top-right'});
        }
        else if(taskList.value !== null && projectList.value !== null && currentCompany.value?.planFeature?.advanceFilterCtrlK){
            e.preventDefault();
            isAdvanceSearch.value = true;
        }
        else{
            $toast.error(t("Toast.Access_Denied"),{position: 'top-right'});
        }
    }
    if(e.key === "Escape"){
        isAdvanceSearch.value = false;
    }
}

// This function is used for the remove event listners for the advance search modal on modal close
const removeKeyListner = () => {
  isAdvanceSearch.value = false;
  document.removeEventListener('keydown', _keyListener);
  document.addEventListener('keydown', _keyListener);
}

function notificationPermissionRequest() {
    if ('Notification' in window) {
        if (Notification.permission === 'granted') {
            generateFcmToken();
        } else if (Notification.permission === 'denied') {
            generateFcmToken(true);
        } else {
            Notification.requestPermission()
            .then(permission => {
                if (permission === 'granted') {
                    generateFcmToken();
                } else {
                    generateFcmToken(true);
                }
            })
            .catch(error => {
                console.error('Error occurred while requesting notification permission:', error);
            });
        }
    } else {
        $toast.error(t("Toast.notification_permission"),{position: 'top-right'});
        // generateFcmToken();
    }
}

function generateFcmToken(type=false) {
    try{
        if(type == false) {
            const userData = apiRequestWithoutCompnay('get',`${env.USER_UPATE}/${userId.value}`)
            userData.then((user) => {
                if(user.status !== 200 || !user.data) {
                    return;
                }
                fcmToken().then((result) => {
                    if(result.status && result.token !== '') {
                        if(localStorage.getItem('webTokens') == null) {
                            const updateObject = {
                                webToken: result.token
                            }
                            apiRequestWithoutCompnay("put",env.UPDATE_SESSION,{
                                userId: userId.value,
                                updateObject:updateObject
                            }).then(()=>{
                                localStorage.setItem('webTokens',result.token);
                            }).catch((err)=>{
                                console.error("ERROR: ", err);
                            });
                        } else if((localStorage.getItem('webTokens') && localStorage.getItem('webTokens') !== result.token)) {
                            let token = localStorage.getItem('webTokens');
                            if(token) {
                                const updateObject = {
                                    webToken: result.token
                                };
                                apiRequestWithoutCompnay("put",env.UPDATE_SESSION,{
                                    userId: userId.value,
                                    updateObject:updateObject
                                }).then(()=>{
                                    localStorage.setItem('webTokens',result.token);
                                }).catch((err)=>{
                                    console.error("ERROR: ", err);
                                });
                            }
                        }
                    }
                })
            })
        } 
        else {
            let token = localStorage.getItem('webTokens');
            if(token) {
                const updateObject = {
                    webToken: ""
                };
                apiRequestWithoutCompnay("put",env.UPDATE_SESSION,{
                    userId: userId.value,
                    updateObject:updateObject
                }).then(()=>{
                    localStorage.removeItem('webTokens',token);
                }).catch((err)=>{
                    console.error("ERROR: ", err);
                });
            }
        }
    } catch(e) {
        console.error(e);
    }
}

watch(underMaintainance, (newVal, oldVal) => {
	if(newVal !== oldVal && newVal === false)  {
		window.location.reload();
	}
})

const changeLanguageHandler = async () => {
    const updateLanguage = await changeLanguage(selectedLanguageCode.value);
    locale.value = selectedLanguageCode.value;
    setSafeLocaleMessage(selectedLanguageCode.value, updateLanguage?.data);
}

const handleSocketsConnection = async () => {
    try {
        const updateObject = {
            lastActive: new Date()
        }
        apiRequestWithoutCompnay("put", env.UPDATE_SESSION,{
            userId: userId.value,
            updateObject:updateObject
        }).then(()=>{
        }).catch((err)=>{
            console.error("ERROR: ", err);
        });
        const serverURL = env.API_URI;
        const namespace = `userid_${companyId.value}_${userId.value}`;
        socket.value = await connectServer(serverURL,namespace,{userRole: getters['settings/companyUserDetail'].roleType});
        commit("settings/mutateSocketInstance", socket.value);
        dispatch("users/myCounts", {uid: userId.value})
        .catch((error) => {
            console.error("ERROR in myCounts: ", error);
        });
        dispatch("settings/setSocketCompanies", {companyId: companyId.value})
        .catch((error) => {
            console.error("ERROR in set socket company: ", error);
        });
        registerSocketLifecycleListeners(serverURL, namespace);
        startPresenceRefresh();
    } catch (error) {
        console.error(error);
    }
}

const registerSocketLifecycleListeners = (serverURL, namespace) => {
    if (socketBeforeUnloadHandler) {
        window.removeEventListener("beforeunload", socketBeforeUnloadHandler);
    }
    if (socketVisibilityHandler) {
        document.removeEventListener("visibilitychange", socketVisibilityHandler);
    }

    socketBeforeUnloadHandler = () => {
        if (socket.value?.id) {
            socket.value.emit('disconnectNameSpace', socket.value.id);
        }
    };

    socketVisibilityHandler = async () => {
        clearTimeout(socketVisibilityDebounce);
        socketVisibilityDebounce = setTimeout(async () => {
            if (document.hidden) {
                clearPresenceRefresh();
                if (socket.value?.connected && socket.value?.id) {
                    socket.value.emit('getRoomList', socket.value.id, (rooms) => {
                        sessionStorage.setItem('joinedRooms', JSON.stringify(rooms));
                    });
                }
                sessionStorage.setItem('tableaveTime', Date.now());
                return;
            }

            if (!userId.value || !companyId.value) return;

            if (!socket.value?.connected) {
                socket.value = await connectServer(serverURL, namespace, {
                    userRole: getters['settings/companyUserDetail'].roleType
                });
                commit("settings/mutateSocketInstance", socket.value);
                dispatch("settings/setSocketCompanies", {companyId: companyId.value})
                .catch((error) => {
                    console.error("ERROR in set socket company: ", error);
                });
            }

            dispatch("users/myCounts", {uid: userId.value})
            .catch((error) => {
                console.error("ERROR in myCounts: ", error);
            });
            tabSync();
            startPresenceRefresh();
        }, 1000)
    };

    window.addEventListener("beforeunload", socketBeforeUnloadHandler);
    document.addEventListener("visibilitychange", socketVisibilityHandler);
}

const refreshPresence = () => {
    if(!companyId.value || !userId.value) {
        return;
    }
    dispatch("settings/refreshCompanyUsersPresence", { companyId: companyId.value }).catch((error) => {
        console.error("ERROR in refresh company users presence: ", error);
    });
}

const startPresenceRefresh = () => {
    clearPresenceRefresh();
    refreshPresence();
    presenceRefreshInterval = setInterval(refreshPresence, 60000);
}

const clearPresenceRefresh = () => {
    if(presenceRefreshInterval) {
        clearInterval(presenceRefreshInterval);
        presenceRefreshInterval = null;
    }
}

onBeforeUnmount(() => {
    window.removeEventListener('open-user-profile', openUserProfileHandler);
    clearTimeout(birthdayCelebrationTimer);
    clearPresenceRefresh();
    clearTimeout(socketVisibilityDebounce);
    if (socketBeforeUnloadHandler) {
        window.removeEventListener("beforeunload", socketBeforeUnloadHandler);
    }
    if (socketVisibilityHandler) {
        document.removeEventListener("visibilitychange", socketVisibilityHandler);
    }
})

onMounted(async() => {
    await router.isReady();
    window.addEventListener('open-user-profile', openUserProfileHandler);

    if (route.meta.lightweight) {
        return;
    }

    changeLanguageHandler()

    if(getters['brandSettingTab/brandSettings'] && !(getters['brandSettingTab/brandSettings']).length){
        dispatch('brandSettingTab/setBrandSettings').catch((error) =>{
            console.error('ERROR in set Set Brand Settings',error)
        })
    }
    getFirebaseData();
    userId.value = localStorage.getItem("userId") !== null ? localStorage.getItem("userId") :  '';
    // try {
    //    paymentInit();
    // } catch (error) {
    //     console.log("Silence Is Golden");
    // }
	window.onresize = (e) => {
		clientWidth.value = e.target.innerWidth;
	}
	document.addEventListener('keydown', _keyListener);
})

const urlRegex = ref(/(https?|ftp):\/\/[^\s/$.?#].[^\s]*/g)
// const urlRegex = ref(/https?:\/\/(?:www\.)?[-a-zA-Z0-9@:%._+~#=]{1,256}\.[a-zA-Z0-9()]{1,6}\b(?:[-a-zA-Z0-9()@:%_+.~#?&/=]*)/g)

const isUserNote = ref(false)

const toggleUserNote = (open = true) => {    
  isUserNote.value = open
}

provide('toggleUserNote', toggleUserNote)

provide("$urlRegex", urlRegex);
provide("$dateFormat", dateFormat);
provide("$companyId", companyId);
provide("$axios", axios);
provide("$userId", userId);
provide("$moneysymbol", '');
provide("$isLogginedIn", logged.value);
provide("$clientWidth", clientWidth);
provide("$selectedCompanyName", '');
provide("$defaultUserAvatar", defaultImageUser);
provide("$defaultTaskStatusImg", defaultTaskStatus);
provide("$defaultGhostCustomUserImg", defaultGhostCustomUser);
provide("$currentLoggedInUserDetails", '');
provide("$mainTour", mainTour);
provide("$socket",socket);

</script>

<style>
#app {
  font-family: 'Inter', sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
}

body {
  margin: 0px;
  background: var(--Gray-6, #F2F2F7);
}

nav {
  padding: 30px;
}

nav a {
  font-weight: bold;
  color: #2c3e50;
}

nav a.router-link-exact-active {
  color: #42b983;
}
.company__logo{
    width: 150px; 
    height: 150px; 
    border: 2px solid #2F399035;
    border-radius: 50%;
    padding: 10px;
}
.advanced__model-css{
    width:100%; 
    height:100%; 
    max-width: 100%!important; 
    border-radius:0!important;
}
.app-wrapper {
    display: flex;
    align-items: stretch;
    height: calc(100vh - 64px);
    min-width: 0;
}

.app-wrapper > :first-child {
    flex: 0 0 auto;
}

.billing__history-wrapper {
    flex: 1 1 0;
    min-width: 0;
    height: calc(100vh - 80px);
    overflow: auto;
    margin: 8px 8px 8px 0px;
    border-radius: 8px;

    font-family: Inter;
}

.missing-phone-modal {
    max-width: 420px;
    width: calc(100vw - 32px);
}

.missing-phone-wrapper {
    display: flex;
    flex-direction: column;
    gap: 12px;
}

.missing-phone-message {
    margin: 0;
    color: #3A3A3C;
    font-size: 14px;
    line-height: 20px;
}

</style>
